import { createLucideIcon } from "lucide-react";

export const ArrowDown = createLucideIcon(
    "arrow-down",
    [
        [
            "path",
            {
                d: "M12 5v14",
                key: "s699le",
            },
        ],
        [
            "path",
            {
                d: "m19 12-7 7-7-7",
                key: "1idqje",
            },
        ],
    ],
);
